import Post from '../../Data/Post';
import ApplyFormStateRules from '../State/ApplyFormStateRules';
import AddJsonValuesIntoPageStructure from '../PageStructure/AddJsonValuesIntoPageStructure';
import GetDefaultValuesFromPage from '../PageStructure/GetDefaultValuesFromPage';
import AddValuesIntoArrayList from '../Forms/AddValuesIntoArrayList';
import AddValuesIntoValueList from '../Forms/AddValuesIntoValueList';
import RequiredFieldCheck from './RequiredFieldCheck';
import GetNextPage from '../PageStructure/GetNextPage';
import GetPreviousPage from '../PageStructure/GetPreviousPage';
import ExtractFieldListFromPageStructure from '../PageStructure/ExtractFieldListFromPageStructure';
import PopulateDynamicLists from '../General/PopulateDynamicLists';
import GetDataEntryFormFromFormNameConfig from '../Forms/GetDataEntryFormFromFormNameConfig';
import PopulateDynamicListsOnLoad from './PopulateDynamicListsOnLoad';
import GetDynamicListNames, {AddDynamicListsIntoForm} from '../Forms/GetDynamicListNames';
import {AddMetaDataToParameters} from '../../components/Containers/FormHandler/Functions/AddFilterMetaData';
import {AddBlankCraftedStructureForPagesWithoutData} from '../../components/Crafted/CraftedFormHandler';
import SpecialCalculations from './SpecialCalculations';
import RemoveHierarchicalElements from './RemoveHierarchicalElements';
import NullInvisiblePageElements from './NullInvisiblePageElements';
import { CalculateStateFromFormStateRules } from '../State/ApplyFormStateRules';


const InvokeFormHandlerUsingForm = (form, recordId, dataRetrievedSuccessfully, errorWhenRetrievingData, button, workflowStateId, filters, selectedRecord) => {
    if (form[0] !== undefined) {
        if (form[0].InitialQuery !== undefined && form[0].InitialQuery !== "") {
            //const standardParameters = [{ Key: 'id', Value: recordId }];

            const parameters = AddMetaDataToParameters(filters, [{ Key: 'id', Value: recordId }]);
            const criteria = { Name: form[0].InitialQuery, Parameters: parameters};
            Post('query/filteredget', criteria, dataRetrievedSuccessfully, errorWhenRetrievingData, { button: button, id: recordId, form: form[0].Name, workflowStateId: workflowStateId});
        } else {
            const dataToUse = form[0].UseListData === undefined || ! form[0].UseListData ? null : selectedRecord;
            dataRetrievedSuccessfully(dataToUse, { button: button, id: recordId, form: form[0].Name, workflowStateId: workflowStateId });
        }
    } else {
        errorWhenRetrievingData("Definition for form " + form.Name + " cannot be found");
    }
}

const InvokeFormHandler = (button, recordId, uievents, forms, dataRetrievedSuccessfully, errorWhenRetrievingData, workflowStateId, filters, selectedRecord) => {
    const action = uievents.filter(a => a.Name === button.UIEvent);

    if (action.length > 0) {
        const form = forms.filter(f => f.Name === action[0].Action);

        InvokeFormHandlerUsingForm(form, recordId, dataRetrievedSuccessfully, errorWhenRetrievingData, button, workflowStateId, filters, selectedRecord);
    }
}

const DataRetrievedHandler = (data, extrainfo, forms, pages, lists) => {
    const formDef = GetDataEntryFormFromFormNameConfig(extrainfo.form, forms, pages, lists);

    ApplyFormStateRules(formDef, formDef.StartState);

    if (data === undefined || data === null) {
        data = GetDefaultValuesFromPage(formDef.Pages, null);
    } else {
        var keys = Object.keys(data);
        if (keys.length === 1 && keys[0] === 'Crafted') { 
            var crafted = data["Crafted"];
            data = GetDefaultValuesFromPage(formDef.Pages, null);
            data["Crafted"] = crafted;
        } else {

            if (! Array.isArray(data)) {
                var defaults = GetDefaultValuesFromPage(formDef.Pages, keys);
                data = {...data, ...defaults};
            }
        }
    }

    formDef.Pages = AddJsonValuesIntoPageStructure(formDef.Pages,data, true);

    formDef.data = data;
    const newPage = formDef.Pages[0];
    if (formDef.data !== undefined && formDef.data.Crafted !== undefined) {
        for (const craft of formDef.data.Crafted) {
            craft.Contents = JSON.parse(craft.Contents);
        }
        if (newPage.Crafted) {
            const newPageData = formDef.data.Crafted.filter((item) => item.Name.toLowerCase() === newPage.Name.toLowerCase());
            formDef.craftedPageData = newPageData[0].Contents;
        }
    }
    AddBlankCraftedStructureForPagesWithoutData(formDef.Pages, data);
    
    PopulateDynamicListsOnLoad(formDef.data, formDef.Pages, lists);
    const dynamicLists = GetDynamicListNames(formDef);

    return { id: extrainfo.id, formDef: formDef, currentState: formDef.StartState, currentPage: newPage, workflowStateId: extrainfo.workflowStateId, dynamicLists: dynamicLists };
}

const IncludeDynamicListsInForm = (state, lists) => {
    AddDynamicListsIntoForm(state.formDef, lists)
    return {...state};
}

const PrepareDataFormSavingHandler = (state, viewName) => {

    if (state.currentPage.Crafted) {
        const craftedItem = state.formDef.data.Crafted.findIndex((item) => item.Name === state.currentPage.Name);

        state.formDef.data.Crafted[craftedItem].Contents = AddValuesIntoArrayList(state.formDef.data.Crafted[craftedItem].Contents, state.fieldChanges);
        if (Array.isArray(state.rootElements)) {
            state.formDef.data = AddValuesIntoValueList(state.formDef.data, state.rootElements);
            state.formDef.Pages = AddJsonValuesIntoPageStructure(state.formDef.Pages,state.formDef.data); 
            state.rootElements = [];
        }
    } else {
        const fieldChanges = Array.isArray(state.rootElements) ? state.fieldChanges.concat(state.rootElements) : state.fieldChanges;
        state.formDef.data = AddValuesIntoValueList(state.formDef.data,fieldChanges);
    }

    state.formDef.data = NullInvisiblePageElements(state.formDef);
    const dataToSave = state.formDef.data;

    if (state.formDef.SaveEvent !== undefined && state.formDef.SaveEvent !== "") {
        dataToSave["Event"] = state.formDef.SaveEvent;
        dataToSave["View"] = viewName;
        if (state.id !== undefined && state.id !== 0  ) { dataToSave["Id"] = state.id; }
        if (state.workflowStateId > 0) { dataToSave["StateId"] = state.workflowStateId; }
    }

    return {...state, data: dataToSave};
}

const NextButtonClickHandler = (page, fieldChangesToUse, sourceOfClick, state, lists) => {
    let errorField = "";
    if (sourceOfClick !== "customnovalidation") {
        errorField = RequiredFieldCheck(state.fieldChanges,page.Required, page.RequiredRule, page.RequiredError, state.formDef.Pages);
    } 
    let newPage;
    let newState = state.currentState;

    if (errorField === "") {

        newState = CalculateStateFromFormStateRules(page, state, sourceOfClick);

        ApplyFormStateRules(state.formDef, newState);
        newPage = GetNextPage(page,state.formDef.Pages);
        state = NavButtonClickHandler(page, newPage, fieldChangesToUse, newState,state, lists);
    }

    return {...state, currentPage: newPage, error: errorField, currentState: newState};
}

const PreviousButtonClickHandler = (page, state) => {
        const newPage = GetPreviousPage(page,state.formDef.Pages);

        let newState = state.currentState;
        newState = newPage.EntryState !== undefined && newPage.EntryState !== "" ? newPage.EntryState : newState;
        ApplyFormStateRules(state.formDef, newState);  
        state = NavButtonClickHandler(page, newPage, undefined, newState, state);

        return state;
    }

const FullScreenButtonClickHander = (state) => {
    state = NavButtonClickHandler(state.currentPage, state.currentPage, undefined, undefined, state);
    return state;
}

const NavButtonClickHandler = (oldPage, newPage, fieldListToUse, newState, state, lists) => {

        let craftedItem;

        if (oldPage.Crafted) {
            craftedItem = state.formDef.data.Crafted.findIndex((item) => item.Name === oldPage.Name);
            if (Array.isArray(fieldListToUse)) {
                state = MultipleFieldContentsChangeHandler("multiplechanges", fieldListToUse, { rootCopy: true}, lists, state);
            }
            //state.formDef.data.Crafted[craftedItem].Contents = AddValuesIntoArrayList(state.formDef.data.Crafted[craftedItem].Contents,state.fieldChanges);

            if (Array.isArray(state.rootElements)) {
                state.formDef.data = AddValuesIntoValueList(state.formDef.data,state.rootElements);
                state.formDef.Pages = AddJsonValuesIntoPageStructure(state.formDef.Pages,state.formDef.data); 
                state.rootElements = [];
            }
        } else {
            state.formDef.data = AddValuesIntoValueList(state.formDef.data,state.fieldChanges);
            state.formDef.Pages = AddJsonValuesIntoPageStructure(state.formDef.Pages,state.formDef.data); 
        }

        if (newPage !== undefined && newPage.Crafted) {
            const newPageData = state.formDef.data.Crafted.filter((item) => item.Name === newPage.Name);
            state.formDef.craftedPageData = newPageData[0].Contents;

            // state.formDef.inputData = oldPage.Crafted ? state.formDef.data.Crafted[craftedItem].Contents : ExtractFieldListFromPageStructure(state.formDef.Pages)

            // Provide all form fields (crafted and standard) as input to the new crafted page.
            let inputData = ExtractFieldListFromPageStructure(state.formDef.Pages);
            for (const crafted of state.formDef.data.Crafted) {
                for (const item of crafted.Contents) {
                    inputData.push(item);
                }
            }
            state.formDef.inputData = inputData;
        }

        newState = newState === undefined ? state.currentState : newState;
        return { ...state, currentState: newState, currentPage: newPage, fieldChanges: []};
    }

const MultipleFieldContentsChangeHandler = (id, value, extraInfo, lists, state) => {
    if (id === "multiplechanges") {
        for (const item of value) {
            state = FieldContentsChangeHandler(item.key,item.value,extraInfo, lists, state);
        }
    } else {
        state = FieldContentsChangeHandler(id,value,extraInfo, lists, state);
    }

    return state;
}
    // Handle contents of fields on form changing.

const FieldContentsChangeHandler = (id, value, extraInfo, lists, state) => {

    let tempFieldChanges = [...state.fieldChanges];
    const rowToChange = tempFieldChanges.findIndex(r => r.key === id);
    if (rowToChange !== -1) {
        tempFieldChanges[rowToChange] = {key: id, value: value};
    } else {
        tempFieldChanges.push({key: id, value: value});
    }

    tempFieldChanges = SpecialCalculations(id, value, tempFieldChanges);

    // Make a copy of the crafted elements in the object root

    const rootCopy = extraInfo === undefined || extraInfo.rootCopy === undefined ? false : extraInfo.rootCopy;
    const rootElements = state.rootElements === undefined ? [] :  [...state.rootElements];
    if (rootCopy && value !== undefined) {
        rootElements.push({key: id, value: value.value});
    }

//    if (extraInfo !== undefined && extraInfo.parentKey !== undefined) {
        PopulateDynamicLists(state.formDef.Pages, lists, id, value);
        tempFieldChanges = RemoveHierarchicalElements(id, value, tempFieldChanges, state.formDef.Pages);
//    }

    state.formDef.data = AddValuesIntoValueList(state.formDef.data,tempFieldChanges);

    const newState = CalculateStateFromFormStateRules(state.currentPage, state);

    return {...state, fieldChanges: tempFieldChanges, rootElements: rootElements };
}

export default InvokeFormHandler;
export { DataRetrievedHandler, PrepareDataFormSavingHandler, NextButtonClickHandler, PreviousButtonClickHandler, FieldContentsChangeHandler, InvokeFormHandlerUsingForm,
     FullScreenButtonClickHander, IncludeDynamicListsInForm, MultipleFieldContentsChangeHandler }